import { INPUT_STYLE, focusRingOff, focusRingOn } from "@/lib/form-styles";

interface MfaCodeInputProps {
	value: string;
	onChange: (value: string) => void;
	/** 認証アプリの 6 桁か、英数字のリカバリーコードか。 */
	kind: "totp" | "recovery";
	autoFocus?: boolean;
	testId?: string;
}

export function MfaCodeInput({ value, onChange, kind, autoFocus, testId }: MfaCodeInputProps) {
	return (
		<input
			type="text"
			value={value}
			onChange={(e) => onChange(e.target.value)}
			autoFocus={autoFocus}
			required
			spellCheck={false}
			autoCapitalize="off"
			{...(kind === "totp"
				? {
						inputMode: "numeric" as const,
						autoComplete: "one-time-code",
						pattern: "[0-9 ]*",
						maxLength: 7,
						placeholder: "123456",
					}
				: { autoComplete: "off", placeholder: "xxxxx-xxxxx" })}
			data-testid={testId}
			style={{
				...INPUT_STYLE,
				fontFamily: "var(--font-mono)",
				letterSpacing: "var(--tracking-label)",
			}}
			onFocus={(e) => focusRingOn(e.currentTarget)}
			onBlur={(e) => focusRingOff(e.currentTarget)}
		/>
	);
}
